import { dispatch, listen } from 'Models/utils/event-bus';

export default function contactFlyout (element) {
    const elements = {
        toggle: document.querySelectorAll('.js-contact-flyout__toggle'),
        personsToggle: element.querySelectorAll('.js-contact-flyout__persons-toggle'),
        persons: element.querySelector('.js-contact-flyout__persons'),
        person: element.querySelectorAll('.js-contact-flyout__person'),
        submit: element.querySelector('.js-contact-flyout__submit'),
    };

    const states = {
        isPersonsList: 'is-persons-list',
        isFlyoutOpen: 'is-contact-flyout',
        isChosenPerson: 'is-chosen-person',
        isCongratulations: 'is-congratulations',
        isContactFlyoutProgress: 'is-contact-flyout-progress',
        isProgress: 'is-progress',
    };

    let personsOpen = false;
    let flyoutOpen = false;
    let innerListenersAdded = false;
    let chosenPersonId;
    let elementClicked = false;

    function init () {
        storePersonId();
        addListeners();
    }

    function addListeners () {
        elements.toggle.forEach(item => {
            item.addEventListener('click', toggleClickHandler);
        });

        // because we can have outer buttons. let's add to then elementClickHandler too.
        elements.toggle.forEach(item => {
            item.addEventListener('click', elementClickHandler);
        });
        listen('contact-flyout-form', formEventHandler);
    }

    function addInnerListeners () {
        if (innerListenersAdded) return false;
        innerListenersAdded = true;
        elements.personsToggle.forEach(toggle => {
            toggle.addEventListener('click', personsToggleClickHandler);
        });
        if (elements.persons) {
            elements.persons.addEventListener('click', personsClickHandler);
        }

        elements.submit.addEventListener('click', submitClickHandler);
        element.addEventListener('click', elementClickHandler);
        document.documentElement.addEventListener('click', documentClickHandler);
    }

    function removeInnerListeners () {
        if (!innerListenersAdded) return false;
        innerListenersAdded = false;
        elements.personsToggle.forEach(toggle => {
            toggle.removeEventListener('click', personsToggleClickHandler);
        });
        elements.persons.removeEventListener('click', personsClickHandler);
        elements.submit.removeEventListener('click', submitClickHandler);
        element.removeEventListener('click', elementClickHandler);
        document.documentElement.removeEventListener('click', documentClickHandler);
    }

    function addPersonsListeners () {
        elements.person.forEach(personItem => {
            personItem.addEventListener('click', personClickHandler);
        });
    }

    function removePersonsListeners () {
        elements.person.forEach(personItem => {
            personItem.removeEventListener('click', personClickHandler);
        });
    }

    function personsToggleClickHandler () {
        togglePersons();
    }

    function toggleClickHandler () {
        toggleFlyout();
    }

    function personsClickHandler () {
        if (!personsOpen) {
            togglePersons();
        }
    }

    function personClickHandler (e) {
        const personEl = e.currentTarget;
        markPerson(personEl);
        storePersonId(personEl);
        togglePersons();
    }

    function submitClickHandler () {
        submitForm();
    }

    function formEventHandler (e) {
        const type = e.type;
        switch (type) {
        case 'success':
            showCongratulationsScreen();
            break;
        case 'progress':
            e.show ? startProgressMode() : stopProgressMode();
            break;
        }
    }

    function documentClickHandler () {
        if (!elementClicked && flyoutOpen) {
            hideFlyout();
        }
    }

    function elementClickHandler () {
        elementClicked = true;
        setTimeout(() => {
            elementClicked = false;
        }, 10);
    }

    function toggleFlyout () {
        flyoutOpen ? hideFlyout() : showFlyout();
    }

    function hideFlyout () {
        flyoutOpen = false;
        element.classList.remove(states.isFlyoutOpen);
        hideCongratulationsScreen();
        removeInnerListeners();
    }

    function showFlyout () {
        flyoutOpen = true;
        element.classList.add(states.isFlyoutOpen);
        addInnerListeners();
        dispatch('contact-flyout-opened');
    }

    function togglePersons () {
        if (personsOpen) {
            element.classList.remove(states.isPersonsList);
            removePersonsListeners();
            requestAnimationFrame(() => {
                personsOpen = false;
            });
        } else {
            element.classList.add(states.isPersonsList);
            addPersonsListeners();
            requestAnimationFrame(() => {
                personsOpen = true;
            });
        }
    }

    function markPerson (personEl) {
        element.querySelector('.' + states.isChosenPerson).classList.remove(states.isChosenPerson);
        personEl.classList.add(states.isChosenPerson);
    }

    function storePersonId (personEl = false) {
        if (!personEl) {
            personEl = element.querySelector('.' + states.isChosenPerson);
        }
        chosenPersonId = personEl.dataset.id;
    }

    function submitForm () {
        dispatch('contact-flyout-submit-form', {
            additionalData: [
                {
                    key: 'chosen_person_id',
                    value: chosenPersonId,
                },
            ],
        });
    }

    function showCongratulationsScreen () {
        element.classList.add(states.isCongratulations);
    }

    function hideCongratulationsScreen () {
        element.classList.remove(states.isCongratulations);
    }

    function startProgressMode () {
        element.classList.add(states.isContactFlyoutProgress);
        elements.submit.classList.add(states.isProgress);
    }

    function stopProgressMode () {
        element.classList.remove(states.isContactFlyoutProgress);
        elements.submit.classList.remove(states.isProgress);
    }

    init();
}
